import React from "react";
import AboutMain from "../../components/About/AboutMain";

const About = () => {
  return (
    <section id="about" data-scroll-section className="overflow-x-hidden">
      <AboutMain />
    </section>
  );
};

export default About;
